import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "config/store";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { IEdoCourseQuiz } from "shared/model/edo-course-quiz.model";
import { deleteEntity } from "shared/reducers/entities/edo-course-quiz.reducer";
import { EntityState } from "shared/reducers/reducer.utils";

interface IDeleteCourseQuizProps {
    courseQuiz: IEdoCourseQuiz;
    open: boolean;
    onClose: () => void;
}

const DeleteCourseQuiz = (props: IDeleteCourseQuizProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoCourseQuiz>>(
        (state) => state.edoCourseQuiz
    );

    const { courseQuiz, open, onClose: handleClose } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(courseQuiz.id));
    };

    useEffect(() => {
        if (open && updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Translate contentKey="entity.delete.title">
                    Confirm delete operation
                </Translate>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Translate
                        contentKey="edocendoApp.edoCourseQuiz.delete.question"
                    />
                </DialogContentText>
                <DialogContentText>
                    Tutti i risultati verranno persi.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                </Button>
                <Button onClick={confirmDelete} color="primary">
                    <Translate contentKey="entity.action.delete">Delete</Translate>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteCourseQuiz;